import React, { useState } from "react";
import styled from "styled-components";
import { Heading } from "../../../constants/assets/containers";
import { isMobile } from "../../../utils";
import AttributeMappingTopSection from "../../../components/Roles/AttributeMappingTopSection";
import AttributeMappingList from "../../../components/Roles/AttributeMappingList";
import AttributeMappingModal from "../../../components/Roles/AttributeMappingFormModal";
import * as AttributeMappingActions from "../../../store/actions/AttributeMapping";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const AttributeMapping = (props) => {
  const [modalState, setModalState] = useState(false);
  const [initialActionType, setInitialActionType] = useState("");
  const { userAttributeListData, updateAttributeMapping, userId } = props;
  const [initialState, setInitialState] = useState({
    emailId: "",
    action: "",
    attribute_type: "",
    attribute_value: "",
    restricted_period: [
      {
        start_time: "",
        end_time: "",
      },
      {
        start_time: "",
        end_time: "",
      },
      {
        start_time: "",
        end_time: "",
      },
    ],
    enabled: true,
  });

  const [editState, setEditState] = useState({
    action: "",
    attribute_type: "",
    attribute_value: "",
    restricted_period: [
      {
        start_time: "",
        end_time: "",
      },
      {
        start_time: "",
        end_time: "",
      },
      {
        start_time: "",
        end_time: "",
      },
    ],
    enabled: true,
  });

  const [newState, setNewState] = useState({
    emailId: "",
    action: "",
    attribute_type: "",
    attribute_value: "",
    restricted_period: [
      {
        start_time: "",
        end_time: "",
      },
      {
        start_time: "",
        end_time: "",
      },
      {
        start_time: "",
        end_time: "",
      },
    ],
    enabled: true,
  });

  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setNewState(JSON.parse(JSON.stringify(initialState)));
    setEditState(JSON.parse(JSON.stringify(initialState)));
    setModalState(false);
  };

  const convertTo24HourFormat = (timeStr) => {
    if (!timeStr) return "";
    const [time, period] = timeStr.split(" ");
    let [hour, minute] = time.split(":");

    hour = parseInt(hour);
    minute = parseInt(minute);

    // Convert to 24-hour format
    if (period.toLowerCase() === "pm" && hour < 12) {
      hour += 12;
    } else if (period.toLowerCase() === "am" && hour === 12) {
      hour = 0;
    }

    // Format hour and minute as two digits
    hour = hour.toString().padStart(2, "0");
    minute = minute.toString().padStart(2, "0");

    return `${hour}:${minute}`;
  };

  const formatTime = (restrictedPeriod) => {
    const formattedPeriods = restrictedPeriod.map(
      ({ start_time, end_time }) => {
        start_time = convertTo24HourFormat(start_time);
        end_time = convertTo24HourFormat(end_time);
        return { start_time, end_time };
      }
    );
    return formattedPeriods;
  };

  const handleToggleUpdate = (data) => {
    const { emailId, ...payload } = data;
    payload.user_id = userId;
    payload.restricted_period = formatTime(payload.restricted_period);
    if (payload.enabled) {
      payload.enabled = false;
    } else {
      payload.enabled = true;
    }
    updateAttributeMapping(payload, initialActionType);
  };

  let modalToRender = <></>;

  switch (modalState) {
    case "Add":
    case "Edit":
      modalToRender = (
        <AttributeMappingModal
          modalState={modalState}
          handleClose={handleClose}
          initialState={initialState}
          editState={editState}
          newState={newState}
          setNewState={setNewState}
          setEditState={setEditState}
          formatTime={formatTime}
          initialActionType={initialActionType}
        />
      );
    default:
      break;
  }

  return (
    <AttributeMappingViewContainer className="attribute-mapping-view">
      <div id="attribute-mapping-holder" className="flex mb-20 justify-between">
        <Heading>Attribute Mapping</Heading>
        <AttributeMappingTopSection
          handleClick={handleClick}
          initialState={initialState}
          setInitialState={setInitialState}
          editState={editState}
          setEditState={setEditState}
          initialActionType={initialActionType}
          setInitialActionType={setInitialActionType}
        />
        <div
          className="attributeMappingListContainer"
          style={{ marginTop: "20px" }}
        >
          <AttributeMappingList
            attributeMappingList={userAttributeListData}
            modalState={modalState}
            handleClick={handleClick}
            initialState={initialState}
            handleToggleUpdate={handleToggleUpdate}
            editState={editState}
            setEditState={setEditState}
            initialActionType={initialActionType}
          />
        </div>
        {modalState && modalToRender}
      </div>
    </AttributeMappingViewContainer>
  );
};

const AttributeMappingViewContainer = styled.div`
  #attribute-mapping-holder {
    flex-direction: ${isMobile() ? "column" : "column"};
  }
`;

const mapDispatchToProps = (dispatch) => {
  return {
    updateAttributeMapping: bindActionCreators(
      AttributeMappingActions.updateAttributeMapping,
      dispatch
    ),
  };
};

const mapStateToProps = (state) => {
  const { AttributeMapping = {} } = state;
  return {
    userAttributeListData: AttributeMapping.userAttributeList,
    userId: AttributeMapping.userId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AttributeMapping);
